interface AssignSurveyConflictStepProps {
    patientName?: string;
}

export default function AssignSurveyConflictStep({ patientName }: AssignSurveyConflictStepProps) {
    return (
        <div>
            <p className="text-foreground">
                O paciente <span className="font-semibold">{patientName}</span> já possui um
                formulário ativo.
            </p>
            <p className="mt-2 text-foreground">Deseja atribuir um novo formulário mesmo assim?</p>
        </div>
    );
}
